<lib-text-common
    [link]="link"
    [tooltipDisabled]="tooltipDisabled"
    [horizAlign]="horizAlign">

    <ng-content>
    </ng-content>

</lib-text-common>
